<app-profile-analysis *ngIf="view_type=='lender_leaves'" [band_id]='band_id' [band_type]='band_type' [ecosystem]='ecosystem' [where_from]='where_from' (changeView)="view='details'"
            (manualEligibity)="manualEligibity($event)" [request_id]="loan?.request_id" [doRefresh]="doRefresh">
</app-profile-analysis>


<app-compulsorydata *ngIf="view_type=='compulsory_data'" [band_id]='band_id' [band_type]='band_type' [ecosystem]='ecosystem' >
</app-compulsorydata>